(() => {
  if (window.tshSampleBound) return;
  window.tshSampleBound = true;
  let busy = false;
  const root = window.Shopify?.routes?.root || '/';
  const samplePath = root + 'pages/free-full-size-salsa-sample';
  const sampleCartKey = 'tshSampleCart';
  function rememberSampleCart(value) {
    try {
      if (value) sessionStorage.setItem(sampleCartKey, 'true');
      else sessionStorage.removeItem(sampleCartKey);
    } catch (_) {}
  }
  function updateSampleNavigation() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) {
      if (document.querySelector('[data-tsh-sample]')) rememberSampleCart(true);
      return;
    }
    const hasSample = !!cartItems.querySelector('[data-tsh-sample-line]');
    const hasItems = !!cartItems.querySelector('.cart-item');
    if (hasItems) rememberSampleCart(hasSample);
    let sampleContext = hasSample;
    try { sampleContext ||= !hasItems && sessionStorage.getItem(sampleCartKey) === 'true'; } catch (_) {}
    if (!sampleContext) return;
    const continueLink = cartItems.querySelector('[data-tsh-cart-continue]');
    const emptyLink = cartItems.querySelector('#tsh-empty-cart-continue');
    if (continueLink) continueLink.href = samplePath;
    if (emptyLink) emptyLink.href = samplePath;
    if (!hasItems) {
      document.querySelectorAll('.announcement-bar-section').forEach(section => { section.hidden = true; });
    }
  }
  function bindSampleNavigation() {
    updateSampleNavigation();
    const cartItems = document.querySelector('cart-items');
    if (cartItems) new MutationObserver(updateSampleNavigation).observe(cartItems.querySelector('.cart__items'), { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSampleNavigation, { once: true });
  else bindSampleNavigation();

  async function request(path, data) {
    const response = await fetch(root + path, data ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data)
    } : { cache: 'no-store' });
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error('Sample cart update failed');
    return result;
  }
  async function changeSample(productId, variantId) {
    const cart = await request('cart.js');
    const samples = cart.items.filter(item => String(item.product_id) === productId);
    const keep = variantId && samples.find(item => String(item.variant_id) === variantId);
    const updates = {};
    for (const item of samples) updates[item.key] = item === keep ? 1 : 0;
    if (samples.length) await request('cart/update.js', { updates });
    if (variantId && !keep) await request('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
    const verified = await request('cart.js');
    const remaining = verified.items.filter(item => String(item.product_id) === productId);
    if (variantId ? remaining.length !== 1 || remaining[0].quantity !== 1 || String(remaining[0].variant_id) !== variantId : remaining.length !== 0) {
      throw new Error('Sample cart verification failed');
    }
  }
  document.addEventListener('click', async event => {
    const choice = event.target.closest('[data-tsh-sample-variant]');
    const change = event.target.closest('[data-tsh-change-flavor]');
    if (!choice && !change) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const container = choice ? choice.closest('[data-tsh-sample]') : change.closest('td');
    const error = container.querySelector('[data-tsh-sample-error]');
    if (error) error.hidden = true;
    const buttons = container.querySelectorAll('[data-tsh-sample-variant]:not(:disabled)');
    buttons.forEach(button => { button.disabled = true; });
    container.setAttribute('aria-busy', 'true');
    try {
      await changeSample((choice ? container : change).dataset.productId, choice?.dataset.tshSampleVariant);
      rememberSampleCart(true);
      window.location.assign(choice ? root + 'cart' : change.href);
    } catch (cause) {
      if (error) {
        if (!error.textContent.trim()) error.textContent = window.cartStrings?.error || 'Please try again.';
        error.hidden = false;
      }
      buttons.forEach(button => { button.disabled = false; });
      container.removeAttribute('aria-busy');
      busy = false;
    }
  });
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
})();

